<template>
  <nx-profile-editor :title="$t('message.menu.myprofile')"
                     :id="staffId"
                     tab="editor"
                     entity="profile" />
</template>

<script>
import BasePage from '@/pages/BasePage';
import NxProfileEditor from '../ProfileEditor';

export default {
  name: 'nx-staff-profile-page',
  extends: BasePage,
  metaInfo() {
    return {
      title: this.$t('message.menu.myprofile'),
      // all titles will be injected into this template
      titleTemplate: '%s | BCube CMS',
    };
  },
  components: {
    NxProfileEditor,
  },
  computed: {
    staffId() {
      return this.$store.getters.loggedStaff.id;
    },
  },
  mounted() {
    this.finishLoading();
  },
};
</script>
